import React from 'react'
import routes from '../config/settings/routes'
import BrandLayout from '../components/Layouts/BrandLayout'
// import ProvidersByBuyersSectionContainer from '../containers/ProvidersByBuyersSection/ProvidersByBuyersSection.container'
import ProvidersByFrameworkSectionContainer from '../containers/ProvidersByFrameworkSection/ProvidersByFrameworkSection.container'
// import ProvidersGeneralDataSectionContainer from '../containers/ProvidersGeneralDataSection/ProvidersGeneralDataSection.container'
import ProvidersSectionContainer from '../containers/ProvidersSection/ProvidersSection.container'
import FooterContainer from '../containers/Footer/Footer.container'
import SearchBuyerPanelContainer from '../containers/SearchBuyerPanel/SearchBuyerPanel.container'
import TopNavbarContainer from '../containers/TopNavbar/TopNavbar.container'

/**
 * The Providers' page.
 */
const Providers = () => (
  <BrandLayout footer={<FooterContainer />}>
    <TopNavbarContainer menuActive={routes.providers} />
    <SearchBuyerPanelContainer />
    <ProvidersSectionContainer />
    {/* <ProvidersGeneralDataSectionContainer /> */}
    <ProvidersByFrameworkSectionContainer />
    {/* <ProvidersByBuyersSectionContainer /> */}
  </BrandLayout>
)

export default Providers
